import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { WidthLayoutService } from 'src/app/layout/service/width.layout.service';

@Component({
    selector: 'app-layout-shell',
    template:
        '<div class="layout-container mx-auto"\n' +
        '     [style.max-width]="(maxWidth$ | async) ?? \'none\'">\n' +
        '  <router-outlet></router-outlet>\n' +
        '</div>\n',
})
export class LayoutShellComponent {
    maxWidth$ = this.layout.maxWidth$;

    constructor(private router: Router, private route: ActivatedRoute, private layout: WidthLayoutService) {
        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            map(() => {
                let r = this.route;
                while (r.firstChild) r = r.firstChild;
                return r.snapshot.data?.['maxWidth'] as string | undefined;
            }),
        ).subscribe(width => this.layout.setMaxWidth(width ?? 'none'));
    }
}
